import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';
import { MetatagsService } from '../_services/metatags.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  // https://youtu.be/w2BV9yGl77Q
  private youTubeLink: string = 'https://www.youtube.com/embed/w2BV9yGl77Q?controls=0&autoplay=1&modestbranding=1';
  public videoUrl: any;
  public videoOpen: boolean = false;

  metaTitle: string = 'Home | CVDPREVENT';
  metaDescription: string = 'The Cardiovascular Disease Prevention Audit (CVDPREVENT) is a national primary care audit that automatically extracts routinely held GP data. This tool provides open access to the data, with clear, actionable insights for those tasked with improving cardiovascular health in England.';

  constructor(
    private metatagsService: MetatagsService,
    private sanitizer: DomSanitizer,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this.metatagsService.updateMetaTags(this.metaTitle, this.metaDescription);
  }

  public toggleVideo(videoState: boolean): void {
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.youTubeLink);
    this.videoOpen = videoState;
    // Collect data for Google Analytics
    this.googleAnalyticsService.watchIntroductoryVideo("Home", "click");
  }

}
